import {
  Authority,
  GetUserQuery,
  BizsolState,
  ConnectBoardState,
} from "@/generated/graphql";

// user type is from GetUserQuery
export const MockUsers = [
  {
    sub: "sub1",
    username: "username1",
    authority: Authority.Admin,
    email: "username1@moneyforward.co.jp",
    lastName: "名字1",
    lastNameKana: "ミョウジカナ1",
    middleName: "ミドルネーム1",
    middleNameKana: "ミドルネームカナ1",
    firstName: "名前1",
    firstNameKana: "ナマエカナ1",
    waitingForChangeToAdmin: false,
    bizsolState: BizsolState.Admin,
    bizsolLoginID: "bizsol-login-id1",
    connectBoardState: ConnectBoardState.Connected,
    connectBoardLoginID: "connect-board-login-id1",
    createdAt: "2022-06-22",
    updatedAt: "2022-06-23",
  },
  {
    sub: "sub2",
    username: "username2",
    authority: Authority.Member,
    email: "username2@moneyforward.co.jp",
    lastName: "名字2",
    lastNameKana: "ミョウジ2",
    middleName: "ミドルネーム2",
    middleNameKana: "ミドルネームカナ2",
    firstName: "名前2",
    firstNameKana: "ナマエ2",
    waitingForChangeToAdmin: false,
    bizsolState: BizsolState.Waiting,
    bizsolLoginID: "bizsol-login-id2-abcde",
    connectBoardState: ConnectBoardState.Connected,
    connectBoardLoginID: "connect-board-login-id2",
    createdAt: "2022-06-24",
    updatedAt: "2022-06-25",
  },
  {
    sub: "sub3",
    username: "username3",
    authority: Authority.Member,
    email: "username2@moneyforward.co.jp",
    lastName: "名字3",
    lastNameKana: "ミョウジ3",
    middleName: "",
    middleNameKana: "",
    firstName: "名前3",
    firstNameKana: "ナマエ3",
    waitingForChangeToAdmin: false,
    connectBoardState: ConnectBoardState.Connected,
    connectBoardLoginID: "connect-board-login-id3",
    createdAt: "2022-06-24",
    updatedAt: "2022-06-25",
  },
  {
    sub: "sub4",
    username: "username4",
    authority: Authority.Admin,
    email: "username4@moneyforward.co.jp",
    lastName: "名字4",
    lastNameKana: "ミョウジ4",
    middleName: "",
    middleNameKana: "",
    firstName: "名前4",
    firstNameKana: "ナマエ4",
    waitingForChangeToAdmin: false,
    connectBoardState: ConnectBoardState.Connected,
    connectBoardLoginID: "connect-board-login-id4",
    createdAt: "2022-06-24",
    updatedAt: "2022-06-25",
  },
  {
    sub: "sub5",
    username: "username5-abcdefghijklmnopqrstuvwxyz",
    authority: Authority.Member,
    email: "username5@moneyforward.co.jp",
    lastName: "名字5",
    lastNameKana: "ミョウジ5",
    middleName: "ミドルネーム5あいうえおabcdefghijklmnopqrstuvwxyz",
    middleNameKana: "",
    firstName: "名前5",
    firstNameKana: "ナマエ5",
    waitingForChangeToAdmin: false,
    connectBoardState: ConnectBoardState.Invalid,
    connectBoardLoginID: "",
    createdAt: "2022-06-24",
    updatedAt: "2022-06-25",
  },
  {
    sub: "01469db6-7b03-49e3-9820-de9482f4fb6d",
    username: "username4",
    authority: Authority.Admin,
    email: "username2@moneyforward.co.jp",
    lastName: "名字",
    lastNameKana: "ミョウジ4",
    middleName: "",
    middleNameKana: "",
    firstName: "名前",
    firstNameKana: "ナマエ4",
    waitingForChangeToAdmin: false,
  },
];
